import React, { useEffect } from 'react'
import BasicCard from '../../../components/card/basiccard/BasicCard'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import styles from "./JoinBoiReporting.styles"
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'

function JoinBoiReportingWaitlist() {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://prodigious-writer-9814.ck.page/f1d315414c/index.js";
    script.async = true;
    script.setAttribute('data-uid', "f1d315414c");
    script.setAttribute('formId', "f1d315414c");
    document.getElementById("convertkit-form").appendChild(script);
  }, []);

  return (
    <div style={styles.container}>
      <div >
        <div>
          <Heading type={HEADING.H1} customStyle={styles.cardHeading}>FINCEN BOI Reporting</Heading>
        </div>
        <div>
          <BasicCard customStyles={styles.offerCardText} >
            <div>
              <Icons familyName={'vec'} iconName={VEC_ICON_NAME.BOI_REPORTING_ICON}  ></Icons>
            </div>
            <div>
              <Heading type={HEADING.H3} customStyle={styles.titleText}  >Leading the way in innovation, Tax1099 proudly offers cutting-edge BOI reporting services. </Heading>
              <p style={styles.subtitleText}>Get ahead of the crowd! Sign up on our waitlist for a special early bird discount. </p>
            </div>
          </BasicCard>
          <div id="convertkit-form" style={styles.waitListFormContainer}></div>

          <div>
            <p style={styles.fs15}>As of January 1, 2024, companies are obligated to submit reports to FinCEN disclosing details about the beneficial ownership or control of their entities.</p>
            <p style={styles.fs15}>FINCEN BOI reporting is an essential regulatory framework designed to promote transparency, protect financial institutions from being used for illicit activities, and contribute to the overall security and integrity of the financial system.</p>
          </div>
        </div>
      </div >
    </div >
  )
}

export default JoinBoiReportingWaitlist